// Angular-Module
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
// ReactiveX for JavaScript
import {Subscription} from 'rxjs';
// Service des übergeordneten Feature-Moduls
import {InstitutionsService} from '../institutions.service';
// Eigener Service
import {InstitutionsSalesService} from './institutions-sales.service';
// Interfaces für Structured Objects einbinden
import {hasOwn} from '@shared/utils';

// Environment
import {environment} from '@environment';

@Component({
    selector: 'phscw-institutions-sales',
    templateUrl: './institutions-sales.component.html',
    styleUrls: ['./institutions-sales.component.scss'],
    standalone: false
})
export class InstitutionsSalesComponent implements OnInit, OnDestroy {
    // Referenzen auf Subject-Subscriptions
    private _subscriptions = new Subscription();

    // ID der aktuell ausgewählten Einrichtung
    institutionId: number;

    // Modul-Daten (Umsätze der Einrichtung)
    data: any = {};

    // EditMode aktiv?
    @Input() editMode = false;

    // "Mehr laden..."
    loadMoreEnabled = false;
    loadMoreVisible = true;
    gridPage = 1;

    // Flag definiert ob gerade geladen wird
    loading = false;

    backendOptions: any;
    @Input() chartLocation = 'institutions';

    shownCharts: string[] = [];

    // Konstruktor (inkl. dependency injection)
    constructor(
        private institutionsService: InstitutionsService,
        private institutionsSalesService: InstitutionsSalesService,
    ) {}

    // Initialisierungen
    ngOnInit() {
        // Events subscriben
        this.initializeEventSubscriptions();
    }

    // Aufräumen
    ngOnDestroy() {
        this._subscriptions.unsubscribe();
    }

    // Events subscriben
    initializeEventSubscriptions() {
        // In der E-Liste wird eine Einrichtung ausgewählt
        this._subscriptions.add(
            this.institutionsService.selectionChanged.subscribe((result) => {
                this.onSelectionChanged(result);
            }),
        );
    }

    /*
     * Nützliche Hilfsfunktion um eine Farbe aufzuhellen
     * https://stackoverflow.com/questions/6443990/javascript-calculate-brighter-colour
     */
    colorIncreaseBrightness(hex: string, percent: number) {
        // strip the leading # if it's there
        hex = hex.replace(/^\s*#|\s*$/g, '');

        // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
        if (hex.length == 3) {
            hex = hex.replace(/(.)/g, '$1$1');
        }

        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);

        const brighterColor: string =
            '#' +
            (0 | ((1 << 8) + r + (256 - r) * percent)).toString(16).substr(1) +
            (0 | ((1 << 8) + g + (256 - g) * percent)).toString(16).substr(1) +
            (0 | ((1 << 8) + b + (256 - b) * percent)).toString(16).substr(1);

        return brighterColor;
    }

    // In der E-Liste wird eine Einrichtung ausgewählt
    onSelectionChanged(id: number) {
        // Bereits vorhandene Daten (einer anderen Einrichtung) entfernen
        this.resetData();
        // ID der aktuellen Einrichtung merken
        this.institutionId = id;
        this.backendOptions = {
            institutionId: this.institutionId,
            location: this.chartLocation,
        };
    }

    // Klick auf "Abbrechen"
    clickCancel(): void {
        // EditMode verlassen
        this.editMode = false;
    }

    // Daten zurücksetzen (z.B. wenn Einrichtung gewechselt wird)
    resetData(): void {
        this.loadMoreEnabled = false;
        this.loadMoreVisible = true;
        this.gridPage = 1;
        this.data = [];
    }
}
